/* Bundle HealthDose — selección de picks, recálculo de tiers y
   add-to-cart múltiple vía window.HDCart (ajax-cart-hd.js).
   Precios en céntimos desde data-price (Liquid); formato de dinero
   replicado desde shop.money_format. */

if (!customElements.get('bundle-builder-hd')) {
  customElements.define('bundle-builder-hd', class extends HTMLElement {
    connectedCallback() {
      // Escalera de 3 tramos desde Theme settings (data-*), ordenada
      // por cantidad. Se aplica el % del tramo más alto alcanzado.
      this.tiers = [
        { qty: parseInt(this.dataset.t2Qty, 10) || 2, pct: parseInt(this.dataset.t2Pct, 10) || 0 },
        { qty: parseInt(this.dataset.t3Qty, 10) || 3, pct: parseInt(this.dataset.t3Pct, 10) || 0 },
        { qty: parseInt(this.dataset.t5Qty, 10) || 5, pct: parseInt(this.dataset.t5Pct, 10) || 0 }
      ].sort((a, b) => a.qty - b.qty);

      this.format = this.dataset.moneyFormat || ('AED ' + '{' + '{amount}' + '}');
      this.totalEl = this.querySelector('[data-bundle-total]');
      this.wasEl = this.querySelector('[data-bundle-was]');
      this.noteEl = this.querySelector('[data-bundle-note]');
      this.cta = this.querySelector('[data-bundle-add]');

      this.addEventListener('click', (e) => {
        const pick = e.target.closest('.hd-pick');
        if (pick && !pick.disabled) {
          pick.setAttribute('aria-pressed',
            pick.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          this.recalc();
          return;
        }
        if (e.target.closest('[data-bundle-add]')) this.addToCart();
      });

      this.recalc();
    }

    // % del tramo más alto que el cliente alcanza por nº de productos.
    rateFor(count) {
      let rate = 0, nextQty = null, nextPct = 0;
      for (const t of this.tiers) {
        if (count >= t.qty) rate = t.pct / 100;
        else if (nextQty === null) { nextQty = t.qty; nextPct = t.pct; }
      }
      return { rate, nextQty, nextPct };
    }

    money(cents) {
      const amount = (cents / 100).toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const noDec = Math.round(cents / 100).toLocaleString('en');
      return this.format
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
        .replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    selected() {
      return [...this.querySelectorAll('.hd-pick[aria-pressed="true"]')];
    }

    recalc() {
      const picks = this.selected();
      const count = picks.length;
      const sum = picks.reduce((s, p) => s + parseInt(p.dataset.price, 10), 0);
      const { rate, nextQty, nextPct } = this.rateFor(count);
      const net = Math.round(sum * (1 - rate));

      this.totalEl.textContent = this.money(net);
      this.wasEl.textContent = rate > 0 ? this.money(sum) : '';
      this.wasEl.hidden = rate === 0;

      const t = this.noteEl.dataset;
      let note = t.tplItems.replace('[count]', String(count));
      if (rate > 0) {
        note += ' · ' + t.tplSaving.replace('[percent]', String(Math.round(rate * 100)));
      } else if (nextQty !== null && count > 0) {
        // Empuja al siguiente tramo: "añade N más para ahorrar X%".
        const need = nextQty - count;
        note += ' · ' + t.tplAddMore
          .replace('[count]', String(need))
          .replace('[percent]', String(nextPct));
      }
      this.noteEl.textContent = note;

      this.cta.setAttribute('aria-disabled', count === 0 ? 'true' : 'false');
    }

    async addToCart() {
      const items = this.selected().map(p => ({
        id: parseInt(p.dataset.variantId, 10), quantity: 1
      })).filter(i => Number.isInteger(i.id) && i.id > 0);

      if (!items.length) return;

      const original = this.cta.textContent;
      this.cta.setAttribute('aria-disabled', 'true');
      try {
        if (window.HDCart && typeof window.HDCart.addItems === 'function') {
          // Ruta preferida: capa global (actualiza shipbar, contador…).
          await window.HDCart.addItems(items);
        } else {
          // Fallback: ajax-cart-hd.js no está cargado en theme.liquid.
          // Añadimos directo y avisamos al resto por el mismo evento.
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Add to cart failed');
          }
          const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(r => r.json());
          document.dispatchEvent(new CustomEvent('hd:cart:updated', { detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
          if (window.HD_CART_REDIRECT === true) { window.location.href = '/cart'; return; }
        }
        this.cta.textContent = this.cta.dataset.addedLabel;
      } catch (err) {
        this.cta.textContent = this.cta.dataset.errorLabel;
        console.error('[BundleHD]', err);
      } finally {
        setTimeout(() => {
          this.cta.textContent = original;
          this.cta.setAttribute('aria-disabled', 'false');
        }, 1600);
      }
    }
  });
}